import { node, string } from 'prop-types';
import React from 'react';

export default function SearchResultsGroup({ title, children }) {
    return (<ul
        className={'search--results-group'}>
        <li
            className={'search--results-group-title'}>{title}</li>
        {children}
    </ul>);
}

SearchResultsGroup.propTypes = {
    title: string,
    children: node,
};